import { render, staticRenderFns } from "./doctype-add-edit.vue?vue&type=template&id=548df4a4&scoped=true&"
import script from "./doctype-add-edit.vue?vue&type=script&lang=js&"
export * from "./doctype-add-edit.vue?vue&type=script&lang=js&"
import style0 from "./doctype-add-edit.vue?vue&type=style&index=0&id=548df4a4&lang=less&scoped=true&"
import style1 from "./doctype-add-edit.vue?vue&type=style&index=1&id=548df4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548df4a4",
  null
  
)

export default component.exports